/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import FMPFooter from "examples/Footers/FMPFooter";

// CentroExcelencia page sections


// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/bg-coworking.jpeg";

function Consultoria() {
  return (
    <>
      <DefaultNavbar
              routes={routes}
              action={{
                type: "internal",
                route: "/pages/ajuda/contate-nos",
                label: "Entre em contato",
                color: "default",
              }}
              transparent
              light
            />
      <MKBox pt={6} px={1} mt={6}>
        <FMPFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Consultoria;